<template>
    <el-menu
            :default-active.sync="activeLink"
            :mode="mode"
            @select="goto"
            :collapse="isCollapse"
            :unique-opened="true"
            background-color="transparent"
            class="main-navigation-menu"
            :class="{'nav-collapsed':isCollapse}">
        <!--<el-menu-item style="border-top: 3px solid #ffe79f; margin-bottom: 3px" index="/profile">-->
            <!--<i class="mdi mdi-account-card-details"></i><span slot="title">Kişisel Bilgilerim</span>-->
        <!--</el-menu-item>-->
        <el-submenu style="border-top: 3px solid #c8bde8" v-if="root || yetkili || yetkiList.yoneticiTanimlama || yetkiList.yoneticiListesi"
                    index="firma" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-city"></i><span>Firma</span>
            </template>
            <el-menu-item v-if="root"  index="/firma/tanimlama">
                <span slot="title">Firma Kayıt</span>
            </el-menu-item>
            <el-menu-item v-if="root || yetkili " index="/firma/detay">
                <span slot="title">Firma Detay</span>
            </el-menu-item>
            <el-submenu index="2-4">
                <template slot="title">Yönetici İşlemleri</template>
                <el-menu-item v-if="root || yetkili ||  yetkiList.yoneticiTanimlama" index="/firma/yoneticitanimlama">
                    <span slot="title">Yönetici Tanımla</span>
                </el-menu-item>
                <el-menu-item v-if="root || yetkili || yetkiList.yoneticiListesi" index="/firma/yoneticiListesi">
                    <span slot="title">Yönetici Listesi</span>
                </el-menu-item>
            </el-submenu>
        </el-submenu>
        <el-submenu style="border-top: 3px solid #9ddebc" v-if="root || yetkili || yetkiList.sayfaTanimlama || yetkiList.sayfaListesi" index="sayfa"
                    popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-page-next"></i><span>Sayfalar</span>
            </template>
            <el-menu-item v-if="root || yetkili || yetkiList.sayfaTanimlama" index="sayfa">
                <span slot="title">Sayfa Tanımla</span>
            </el-menu-item>
            <el-menu-item v-if="root || yetkili || yetkiList.sayfaListesi" index="sayfa">
                <span slot="title">Sayfa Listesi</span>
            </el-menu-item>
        </el-submenu>
        <el-submenu
                style="border-top: 3px solid #f9c9de"
                v-if="root || yetkili || yetkiList.haberTanimlama || yetkiList.haberListesi || yetkiList.haberKategoriTanimlama || yetkiList.haberKategoriListesi"
                index="haber" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-bullhorn"></i><span>Bültenler</span>
            </template>
            <el-menu-item v-if="root || yetkili || yetkiList.haberTanimlama" index="haber">
                <span slot="title">Bülten Tanımla</span>
            </el-menu-item>
            <el-menu-item v-if="root || yetkili || yetkiList.haberListesi" index="haber">
                <span slot="title">Bülten Listesi</span>
            </el-menu-item>
            <el-menu-item v-if="root || yetkili || yetkiList.haberKategoriListesi || yetkiList.haberKategoriTanimlama"
                          index="haber">
                <span slot="title">Bülten Kategorileri</span>
            </el-menu-item>
        </el-submenu>
        <el-submenu
                style="border-top: 3px solid rgba(249,115,97,0.73)"
                index="proje" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-briefcase-plus"></i><span>Projeler</span>
            </template>
            <el-menu-item index="/proje/tanimla">
                <span slot="title">Proje Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/proje/liste">
                <span slot="title">Proje Listesi</span>
            </el-menu-item>
            <el-submenu index="2-4">
                <template slot="title">Proje Kategorileri</template>
                <el-menu-item index="/proje/kattanimla">
                    <span slot="title">Proje Kategori Tanımla</span>
                </el-menu-item>
                <el-menu-item  index="/proje/katliste">
                    <span slot="title">Proje Kategori Liste</span>
                </el-menu-item>
            </el-submenu>
        </el-submenu>
        <el-submenu
                style="border-top: 3px solid #837e90"
                v-if="root || yetkili || yetkiList.popupTanimlama || yetkiList.popuplistesi" index="popup" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-bell-alert"></i><span>Pop-Up</span>
            </template>
            <el-menu-item v-if="root || yetkili || yetkiList.popupTanimlama" index="pop">
                <span slot="title">Popup Tanımla</span>
            </el-menu-item>
            <el-menu-item v-if="root || yetkili || yetkiList.popuplistesi" index="pop">
                <span slot="title">Popup Liste</span>
            </el-menu-item>
        </el-submenu>
        <el-menu-item style="border-top: 3px solid rgba(115,255,130,0.71)" index="/rakamlar">
            <i class="mdi mdi-numeric"></i><span slot="title">Rakamlar</span>
        </el-menu-item>
        <el-menu-item v-if="root || yetkili || yetkiList.iletisim" style="border-top: 3px solid rgba(207,114,255,0.5)" index="/iletisim/liste">
            <i class="mdi mdi-email-search"></i><span slot="title">İletişim</span>
        </el-menu-item>
    </el-menu>
</template>

<script>
    import seoService from '../WSProvider/SeoService'

    import {detect} from 'detect-browser'
    import JQuery from 'jquery';

    let $ = JQuery;
    const browser = detect()
    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: 'Nav',
        props: ['mode', 'isCollapse'],
        data() {
            return {
                root: false,
                yetkili: false,
                isIe: true,
                isEdge: true,
                activeLink: null,
                tabList: [],
                yetkiList: {
                    yoneticiTanimlama: false,
                    yoneticiListesi: false,
                    sayfaTanimlama: false,
                    haberTanimlama: false,
                    haberKategoriTanimlama: false,
                    sayfaListesi: false,
                    haberListesi: false,
                    haberKategoriListesi: false,
                    popupTanimlama: false,
                    popuplistesi: false,
                    sliderTanimlama: false,
                    sliderListesi: false,
                    iletisim: false
                }
            }
        },
        methods: {
            goto(index, indexPath, id) {
                let self = this;
                if (this.$store.state.tabList.length === 0) {
                    this.tabList = [];
                }
                var obj = this.tabList.find(data => data.title === id.$el.textContent);
                var name = linkTemizle(id.$el.textContent.replace(" ", ""));
                if (obj === undefined) {
                    this.tabList.push({
                        title: id.$el.textContent,
                        name: name,
                        contentName: name
                    });
                    this.$store.commit('changeTabList', this.tabList);
                    this.$store.commit('changeActiveTabs', name);
                } else {
                    this.$store.commit('changeActiveTabs', name);
                }
                this.$emit('push-page', {page: index});
                $(".horizontal-nav.pos-top").addClass("shadowBox");

            },
            closeSidebar() {
                this.openSidebar = false
            },
            setLink(path) {
                this.activeLink = path
            }
        },
        created() {
            if (browser.name !== 'ie') this.isIe = false
            if (browser.name !== 'edge') this.isEdge = false
            this.setLink(this.$router.currentRoute.path)
            this.$router.afterEach((to, from) => {
                this.setLink(this.$router.currentRoute.path)
            })
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataSidas")) {
                userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
                if (userDataSidas["yetki"]) {
                    userDataSidas["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-859359':
                                self.yetkiList.yoneticiTanimlama = true;
                                break;
                            case 'YK-729237':
                            case 'YK-793129':
                                self.yetkiList.yoneticiListesi = true;
                                break;
                            case 'YK-726696':
                                self.yetkiList.popupTanimlama = true;
                                break;
                            case 'YK-474323':
                            case 'YK-795990':
                            case 'YK-470160':
                                self.yetkiList.popuplistesi = true;
                                break;
                            case 'YK-188079':
                                self.yetkiList.sayfaTanimlama = true;
                                break;
                            case 'YK-621180':
                            case 'YK-440561':
                            case 'YK-322737':
                                self.yetkiList.sayfaListesi = true;
                                break;
                            case 'YK-938962':
                                self.yetkiList.sliderTanimlama = true;
                                break;
                            case 'YK-685310':
                            case 'YK-945722':
                            case 'YK-741576':
                                self.yetkiList.sliderListesi = true;
                                break;
                            case 'YK-396920':
                                self.yetkiList.haberKategoriTanimlama = true;
                                break;
                            case 'YK-314433':
                            case 'YK-146334':
                                self.yetkiList.haberKategoriListesi = true;
                                break;
                            case 'YK-921571':
                                self.yetkiList.haberTanimlama = true;
                                self.yetkiList.haberKategoriListesi = true;
                                break;
                            case 'YK-558513':
                            case 'YK-410578':
                            case 'YK-863391':
                                self.yetkiList.haberListesi = true;
                                break;
                            case 'YK-169980':
                            case 'YK-501088':
                                self.yetkiList.iletisim = true;
                                break;
                        }
                    });
                }
                switch (userDataSidas.tur) {
                    case "1":
                        self.root = true;
                        break;
                    case "2":
                        self.yetkili = true;

                }
            }
        },
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables';

    .main-navigation-menu {
        transition: width .5s;

        &:not(.el-menu--collapse) {
            .el-submenu__title, .el-menu-item {
                height: 40px;
                line-height: 40px;
                background-color: transparent !important;
            }

            &:not(.el-menu--horizontal) {
                .el-menu-item, .el-submenu {
                    position: relative;

                    &::before {
                        content: '';
                        display: block;
                        width: 0px;
                        height: 1px;
                        position: absolute;
                        bottom: 10px;
                        left: 30px;
                        background: $text-color;
                        z-index: 1;
                        opacity: 0;
                        transition: all .7s cubic-bezier(.55, 0, .1, 1);
                    }

                    &:hover {
                        &::before {
                            width: 100px;
                            opacity: 1;
                            //left: 50px;
                            transform: translate(20px, 0);
                        }
                    }

                    &.is-active {
                        &::before {
                            background: $text-color-accent;
                        }
                    }
                }
            }

            .el-submenu.is-opened {
                //background: #edf1f6 !important;
                //background: rgba(223, 228, 234, 0.38) !important;
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    width: 2px;
                    position: absolute;
                    top: 40px;
                    bottom: 10px;
                    left: 31px;
                    background: $text-color;
                    z-index: 1;
                }

                &::before {
                    display: none;
                }

                .el-menu-item, .el-submenu {
                    &::before, &::after {
                        display: none;
                    }
                }
            }

            .el-menu-item-group__title {
                padding: 15px 0 0px 20px;
                color: transparentize($text-color, 0.65);
            }
        }

        .el-submenu__title, .el-menu-item:not(.is-active) {
            color: $text-color;

            i {
                color: $text-color;
            }
        }

        &.el-menu--collapse {
            .el-menu-item-group__title {
                padding: 15px 0 0px 0px;
                width: 100%;
                text-align: center;
            }

            .el-submenu__title:hover, .el-menu-item:hover {
                background-color: rgba(0, 0, 0, 0.05) !important;
            }
        }

        &.el-menu--horizontal {
            white-space: nowrap;
            /*width: fit-content;
            width: max-content;*/
            overflow: hidden;
            display: table;

            & > * {
                float: inherit !important;
                display: inline-block;
            }
        }

        &.nav-collapsed {
            .el-menu-item, .el-submenu__title {
                & > span {
                    display: none;
                }
            }
        }
    }

    .main-navigation-submenu {
        .el-menu {
            background: #fff !important;

            .el-menu-item:not(.is-active) {
                color: $text-color;
            }

            .el-menu-item:hover {
                background-color: transparentize($background-color, 0.3) !important;
            }
        }
    }

    .main-navigation-menu:not(.el-menu--collapse):not(.el-menu--horizontal) .el-submenu {
        position: relative;
        border: none !important;
    }
    .main-navigation-menu:not(.el-menu--collapse):not(.el-menu--horizontal) .el-menu-item, .main-navigation-menu:not(.el-menu--collapse):not(.el-menu--horizontal) .el-submenu {
        position: relative;
        border: none !important;
    }
    @media (min-width: 768px) {
        @import '../assets/scss/_variables';
        .main-navigation-menu {
            transition: width .5s;

            &:not(.el-menu--collapse) {
                .el-submenu__title, .el-menu-item {
                    height: 70px;
                    line-height: 20px;
                    text-align: -webkit-center;
                    background-color: transparent !important;
                }
            }
            &.el-menu--horizontal {
                white-space: nowrap;
                overflow: hidden;
                display: table;

                & > * {
                    float: inherit !important;
                    display: inline-block;
                    border-right: 1px solid #dadfe3;
                }
            }
        }
        .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
            display: table-cell;
            position: relative;
            right: 3px;
            bottom: 7px;
            vertical-align: middle;
        }
        .el-submenu__title span {
            position: relative !important;
            bottom: 2px !important;
        }
        .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
            position: relative;
            top: 2px;
        }
        .main-navigation-submenu {
            .el-menu {
                background: #e3eaf0 !important;

                .el-menu-item:not(.is-active) {
                    color: $text-color;
                }

                .el-menu-item:hover {
                    background-color: transparentize($background-color, 0.3) !important;
                }
            }
        }
        .iletisimNav{
            border-bottom-color: transparent;
            background-color: transparent;
            border-top: 5px solid #CE749E;
            --currentColor: #CE749E;
            color: rgb(255, 255, 255);
        }
        .iletisimNav:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 0;
            background: var(--currentColor);
            left: 0;
            top: 0;
            z-index: -1;
            transition: .3s;
        }
        .iletisimNav:hover:before {
            height: 100%;
        }
    }

</style>
<style lang="scss" scoped>
    @import '../assets/scss/_variables';

    .el-menu {
        border: none;
    }

    .el-menu::before, .el-menu::after {
        display: none;
    }

    .el-submenu, .el-menu-item {
        .mdi {
            vertical-align: middle;
            margin-right: 5px;
            display: inline-block;
            width: 24px;
            text-align: center;
            font-size: 18px;
        }
    }
    @media (min-width: 768px) {
        .el-submenu, .el-menu-item {
            .mdi {
                vertical-align: middle;
                position: relative;
                top: 5px;
                display: flex;
                width: 24px;
                text-align: center;
                font-size: 17px;
            }
        }
    }

</style>
